"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormActionRequestState = void 0;
var FormActionRequestState;
(function (FormActionRequestState) {
    FormActionRequestState["NEW"] = "NEW";
    FormActionRequestState["SUCCESS"] = "SUCCESS";
    FormActionRequestState["FAILED"] = "FAILED";
    FormActionRequestState["IGNORED"] = "IGNORED";
})(FormActionRequestState = exports.FormActionRequestState || (exports.FormActionRequestState = {}));
//# sourceMappingURL=formActionRequestState.js.map